import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('countries', app)

  store.mutations.setList = function (state, { data, listName }) {
    const list = data
    let pt = list.find((item) => {
      return item.name === 'Portugal'
    })
    pt = JSON.parse(JSON.stringify(pt))
    pt._k = -1
    list.unshift(pt)
    state.list[listName].data = list
    const listById = {}
    list.forEach((item) => {
      listById[item._id] = item
    })
    state.listById[listName] = listById
  }

  return store
}
